export default __webpack_public_path__ + "static/media/bg2.0489bfc0.mp4";